import type { QueryBuilder } from "@cgarciagarcia/react-query-builder";
import { createQueryKeys } from "@lukemorales/query-key-factory";

import {
  getInsuranceProviders,
  getProviderMappings,
  importInsuranceProviders,
} from "./api";

export const queries = createQueryKeys("insuranceProviders", {
  list: ({
    queryBuilder,
  }: {
    queryBuilder?: QueryBuilder<Record<string, string> | undefined>;
  }) => ({
    queryKey: ["insuranceProviders", queryBuilder?.toArray()],
    queryFn: () => getInsuranceProviders({ queryBuilder }),
  }),
  byProvider: (providerId: number) => ({
    queryKey: ["insuranceProviders", "byProvider", providerId],
    queryFn: () => getProviderMappings(providerId),
  }),
});

export const mutations = { importInsuranceProviders };
